module.exports = __webpack_public_path__ + "img/face-cowboy-hat.c28f9aa4.svg";